import { Heading, Paragraph } from "../../../atoms";
import { Box, Flex } from "../../../cores";
import { useViewContext } from "../../../hooks";
import { IconFargBetyg } from "../../../icons";

interface IRiksbetygDescription {
  descriptionTitle: string;
  descriptionText: Array<string>;
}

const RiksbetygDescription = ({
  descriptionTitle,
  descriptionText,
}: IRiksbetygDescription) => {
  const { isMobile } = useViewContext();

  return (
    <Box
      sx={{
        width: "100%",
        "> div": {
          marginY: 10,
          "> p": {
            marginLeft: "sm",
            fontSize: ["xs", null, "16px", null, null],
          },
        },
      }}
    >
      <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
        {descriptionTitle}
      </Heading>
      {[...Array(3)].map((_: string, index: number) => {
        const str = (index + 1).toString();
        index *= 3;
        return index <= 6 ? (
          <Flex key={descriptionText[index]}>
            <IconFargBetyg value={str} />
            <Paragraph>
              <strong>{descriptionText[index]}</strong>
              <br></br>
              {descriptionText[index + 1]}
              <br></br>
              {descriptionText[index + 2]}
            </Paragraph>
          </Flex>
        ) : null;
      })}
    </Box>
  );
};

export default RiksbetygDescription;
